export default {"src":"/_next/static/media/exit.5befde52.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};